import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Paper, Grid, Alert } from '@mui/material';

// Re-export common styles
export { FormPageContainer, FormHeader, FormSubHeader, StyledForm, SubmitButton, RadioGroupContainer, StyledRadioGroup, ButtonGroupContainer, BackButton } from './MaritalStatusForm.styles'; // Reusing

// Specific styles
export const SectionContainer = styled(Paper)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(3),
    backgroundColor: theme.palette.grey[50], // Light background for sections
}));

export const ChildrenListGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(2.5),
}));

export const ChildItemPaper = styled(Paper)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    height: '100%', // Ensure items in grid take full height
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
}));


export const AgeDisplayTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    color: theme.palette.info.main, // Using info color for age
}));

export const AddButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
}));

export const RemoveButton = styled(Button)(({ theme }) => ({
    marginTop: 'auto', // Push remove button to bottom in flex column
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    padding: theme.spacing(0.8, 1.8),
    fontSize: '14px',
     '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
}));


export const TrustSummaryBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.info.light, // Use theme color
    color: theme.palette.info.contrastText,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(2, 0),
    '& ul': { // Style list inside
        paddingLeft: theme.spacing(3),
        margin: 0,
    },
    '& li': {
        marginBottom: theme.spacing(0.5),
    }
}));

export const InfoAlert = styled(Alert)(({ theme }) => ({
   // Uses MUI Alert component for info box
   marginTop: theme.spacing(1),
   marginBottom: theme.spacing(2),
}));

export const TrusteeDetailsBox = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
}));